import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-mon-adhesion',
  templateUrl: './mon-adhesion.component.html',
  styleUrls: ['./mon-adhesion.component.scss']
})
export class MonAdhesionComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }
  configuration = this.configurationService.get();
  ngOnInit(): void {
  }

}
